module.exports = __webpack_public_path__ + "static/media/search.a852ab42.svg";